import { commonService } from '.';

const downloadFile = (body) => {
    return commonService.getWithParam('File/download', body);
};

const addFile = (body, idUser) => {
    return commonService.post('File/add?idUser=' + idUser, body);
};

const deleteFile = (id, idUserFile, data) => {
    return commonService.deleteWithParam('File?id=' + id + '&idUserFile=' + idUserFile, data);
};

const savePjCertification = (id, action, idTraining, body) => {
    return commonService.post('File/save?id=' + (id ?? 0) + '&action=' + action + '&idTraining=' + idTraining, body);
}

const getFile = (fileName) => {
    return commonService.getWithParam('File/getFile?fileName=' + fileName, null);
};

const getValidUploadFileExtension = () => {
    return commonService.getWithParam('File/validUploadFileExtension', null);
};

export const fileService = {
    addFile,
    deleteFile,
    downloadFile,
    savePjCertification,
    getFile,
    getValidUploadFileExtension
};